import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { MoreInfoButton } from '../MoreInfoButton';

import { ParticipateButton } from './ParticipateButton';

import bgMobileGold from '@/assets/tournaments/bg_mobile_gold.jpg';
import { Button } from '@/components';
import ROUTES from '@/router/routes';
import { ResponseInfoFeoroUsuario } from '@/types/goldDate';
import {
  toLowerCase,
  extractNumberWithHash,
  formatNumberToLocale,
} from '@/utils';

type MobileContentProps = {
  dataInitUsuarioOro?: ResponseInfoFeoroUsuario;
  onCardButtonClick: () => void;
};

const MobileContent = ({
  dataInitUsuarioOro: data,
  onCardButtonClick,
}: MobileContentProps) => {
  const navigate = useNavigate();
  const disabledCondition = data?.ta;
  const cantPart = data?.ta?.cantPart ?? 0;

  const isEndedAndNoParticipate = !data?.participaActual && data?.estaPublicado;

  const actionShowTourney = useMemo(() => {
    return (
      (data &&
        data?.actualesSinPublicar &&
        data?.actualesSinPublicar.length > 0) ||
      (data && data?.todosLosPublicados && data?.todosLosPublicados?.length > 0)
    );
  }, [data]);

  const ActionShowTourney = useCallback(() => {
    return (
      <Button
        className="text-gdt-blue font-bold"
        type="button"
        variant="text"
        // muestro el listado de participando -presente o pasado
        onClick={() => navigate(ROUTES.goldDate.list, { state: true })}
      >
        Ver mis torneos Fecha de Oro
      </Button>
    );
  }, [navigate]);

  return (
    <>
      {disabledCondition && !isEndedAndNoParticipate && !data?.estaInactiva && (
        <div className="flex gap-3 items-center mt-4">
          <p className="text-base font-bold">{data?.ta?.nombreFecha}</p>
          <p className="text-gdt-gray-4 font-semibold text-xs">
            {cantPart < 20
              ? `${20 - cantPart} cupos disponibles`
              : 'Sin cupos disponibles'}
          </p>
        </div>
      )}
      <div className="flex flex-col shadow-xl">
        <div
          className="flex items-center w-full h-[83px] text-white bg-center bg-cover bg-no-repeat rounded-t-lg mt-4"
          style={{
            backgroundPosition: 'right 70%',
            backgroundImage: `url(${bgMobileGold})`,
          }}
        >
          <div className="px-5 pt-4 font-bebas uppercase text-3xl leading-[22px] font-normal">
            <h1>FECHA DE ORO</h1>
          </div>
        </div>
        <div className="bg-white p-4 rounded-b-lg">
          {(data?.estaInactiva || isEndedAndNoParticipate) && (
            <>
              <h2 className="text-base font-bold text-gdt-blue">
                {isEndedAndNoParticipate ? (
                  <p className="text-black font-medium mt-2 mb-6 pl-3">
                    Fecha de Oro ya finalizó.
                    <br />
                    ¡Te esperamos en la próxima edición!
                  </p>
                ) : (
                  data?.msjInactiva && (
                    <p className="p-4 pb-8 lg:text-gdt-blue text-black font-medium">
                      {data?.msjInactiva}
                    </p>
                  )
                )}
              </h2>
              <div className="flex flex-col text-center items-center my-2 space-y-3">
                {/* BOTON MAS INFORMACION */}
                <MoreInfoButton />
              </div>
            </>
          )}
          {!isEndedAndNoParticipate && !data?.estaInactiva && (
            <>
              {disabledCondition ? (
                <div className="flex flex-col text-center items-center gap-3">
                  <p className="text-xl text-gdt-status-yellow">{`Fecha de Oro ${extractNumberWithHash(
                    data?.ta?.nombre
                  )}`}</p>
                  <p className="text-base font-bold">{`Participás por $${formatNumberToLocale(
                    data?.premio ?? 0
                  )}`}</p>
                  <p className="text-gdt-gray-4 font-semibold text-xs">
                    {`Pin especial $${formatNumberToLocale(
                      data?.precioDeListaPin ?? 0
                    )}`}
                  </p>
                  <ParticipateButton
                    dataInitUsuarioOro={data}
                    onClick={() => onCardButtonClick()}
                  />
                  {actionShowTourney && data && data?.ta && (
                    <ActionShowTourney />
                  )}
                  <div className="flex flex-col text-center items-center my-2 space-y-3">
                    {/* BOTON MAS INFORMACION */}
                    <MoreInfoButton />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col text-center items-center gap-3">
                  <p className="text-base font-bold text-gdt-blue">
                    {data?.msjInactiva || '¡Muy pronto podrás participar!'}
                  </p>
                  {!data?.estaInactiva && (
                    <strong>{`La primera Fecha de Oro se juega en la ${toLowerCase(
                      data?.primerFecha
                    )}.`}</strong>
                  )}
                  {actionShowTourney && data && !data?.ta && (
                    <ActionShowTourney />
                  )}
                  <div className="flex flex-col text-center items-center my-2 space-y-3">
                    {/* BOTON MAS INFORMACION */}
                    <MoreInfoButton />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="flex flex-col text-center items-center my-6 space-y-3">
        {actionShowTourney && data?.estaInactiva && <ActionShowTourney />}
      </div>
    </>
  );
};

export default MobileContent;
